import React, { useCallback, useState } from "react";
import { VStack } from "@/components/ui/vstack";
import { Heading } from "@/components/ui/heading";
import { Text } from "@/components/ui/text";
import { Button, ButtonText, ButtonSpinner } from "@/components/ui/button";
import { AuthLayout } from "@/screens/auth/auth.layout";
import { useSession } from "@/utils/session.ctx";
import { HStack } from "@/components/ui/hstack";
import Logo from "@/screens/menu/logo/logo";
import { Box } from "@/components/ui/box";
import { Pressable } from "@/components/ui/pressable";
import { Link as ExpoLink, useFocusEffect } from "expo-router";
import { useRouter } from "expo-router";
import { ColorSchemeName, Platform } from "react-native";
import { useColorScheme } from "@/components/useColorScheme";
import { AppStoreButtons } from "@/screens/common/app.store.buttons";
import { useAttribution } from "@/screens/common/attribution.provider";

export default function LoginWithLeftBackground() {
  const { signIn, isAuthenticated } = useSession();
  const [signInPending, setSignInPending] = useState(false);
  const colorScheme: ColorSchemeName = useColorScheme();
  const router = useRouter();
  const { attributionId } = useAttribution();

  const onSignIn = () => {
    setSignInPending(true);
    signIn({
      firstScreen: "sign_in",
    })
      .catch((_) => {})
      .finally(() => {
        setSignInPending(false);
      });
  };

  const onSignUp = () => {
    signIn({
      firstScreen: "register",
    }).catch((_) => {});
  };

  useFocusEffect(
    useCallback(() => {
      if (isAuthenticated) {
        router.replace("/");
      }
    }, [isAuthenticated])
  );

  return (
    <AuthLayout>
      <VStack className="max-w-screen-sm w-full h-full" space="md">
        <Box className="w-36 h-11 md:hidden">
          <Logo
            color={colorScheme === "dark" ? "white" : "black"}
            fill={colorScheme === "dark" ? "white" : "black"}
            width="100%"
            height="100%"
          />
        </Box>
        <VStack className="w-full h-full justify-center -mt-11">
          <VStack>
            <Heading className="md:text-center" size="3xl">
              Welcome!
            </Heading>
            <Text className="md:text-center">
              Please sign in to start using GoTips
            </Text>
          </VStack>

          <VStack className="w-full my-7" space="lg">
            <Button
              className="w-full gap-2"
              onPress={onSignIn}
              isDisabled={signInPending}
            >
              <ButtonText className="font-medium">Sign in</ButtonText>
              {signInPending && <ButtonSpinner />}
            </Button>
            <HStack className="self-center" space="sm">
              <Pressable onPress={onSignUp} className="flex-row">
                <Text size="md">Don't have an account? </Text>
                <Text
                  size="md"
                  className="font-medium text-primary-700 group-hover/link:text-primary-600  group-hover/pressed:text-primary-700"
                >
                  Sign up
                </Text>
              </Pressable>
            </HStack>
            {Platform.OS === "web" && !attributionId && <AppStoreButtons />}
          </VStack>
        </VStack>
      </VStack>
    </AuthLayout>
  );
}
